<template>
  <!-- <v-fade-transition mode="out-in">
    <router-view v-if="$store.state.user || render" />
    
  </v-fade-transition> -->
  <router-view v-slot="{ Component }" v-if="$store.state.user || render">
    <v-fade-transition mode="out-in">
      <component :is="Component" />
    </v-fade-transition>
  </router-view>
  <!-- <LoadingScreen v-show="render" /> -->

  <DataPrivacyModal v-if="showPrivacyModal" @agreed="showPrivacyModal = false" />
</template>

<script>
import LoadingScreen from "./components/Utils/LoadingScreen.vue";
import DataPrivacyModal from "./components/Dialogs/DataPrivacyModal.vue";
export default {
  name: "App",
  components: {
    LoadingScreen,
    DataPrivacyModal,
  },
  data: () => ({
    render: false,
    showPrivacyModal: false,
  }),
  created: function () {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      // this.$router.push("/");
      // setTimeout(() => {
      //   location.reload();
      // }, 100);
    } else {
      this.render = true;
      this.getUser();
    }
  },

  computed: {},
  methods: {
    getType(utype) {
      let type = "";
      if (utype == 1) {
        type = "superadmin";
      }
      if (utype == 2) {
        type = "admin";
      }
      if (utype == 3) {
        type = "ojt-coordinator";
      }
      if (utype == 4) {
        type = "instructor";
      }
      if (utype == 5) {
        type = "dean";
      }
      if (utype == 6) {
        type = "vpaa";
      }
      if (utype == 7) {
        type = "organization";
      }
      if (utype == 8) {
        type = "student";
      }
      if (utype == 9) {
        type = "field-officer";
      }
      if (utype == 10) {
        type = "program-chair";
      }
      return type;
    },
    getUser() {
      if (this.$store.getters.getIsAuthenticated == 1) {
        if (localStorage.getItem("token")) {
          this.axiosCall("/auth/current_user", "GET")
            .then((res) => {
              let data = res.data.userdetail;
              console.log("AS", res.data);
              if (res.data) {
                this.$store.dispatch("setUser", data);
                this.$store.dispatch("setIsAuthenticated", 1);
                if (this.$route.path === "/login") {
                  if (
                    data.user.usertypeID == 3 &&
                    data.user.user_roleID.length > 1
                  ) {
                    this.$store.dispatch(
                      "setActiveRole",
                      data.user.user_roleID[0],
                    );
                  }
                  // Show Data Privacy modal if user hasn't agreed yet (DB is source of truth)
                  const agreedInDB = data.user.privacy_agreed;
                  const agreedInCache = localStorage.getItem(`privacy_agreed_${data.user.id}`);
                  if (!agreedInDB && !agreedInCache) {
                    this.showPrivacyModal = true;
                  }
                  this.$router.push(
                    "/" + this.getType(data.usertype.id) + "/dashboard",
                  );
                }
              } else {
                this.$store.dispatch("setUser", null);
                this.$store.dispatch("setIsAuthenticated", 0);

                location.reload();
              }
            })
            .catch((error) => {
              console.log(error);
              this.render = true;
            });
        } else {
          this.render = true;
        }
      } else {
        this.$store.dispatch("setUser", null);
        this.$store.dispatch("setIsAuthenticated", 0);
        // setTimeout(() => {
        //   location.reload();
        // }, 500);
      }
    },

    // portalLogin(email, password) {

    // },
  },
};
</script>
<style>
/* SCROLL BAR CUSTOMIZE*/
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(206, 196, 196);
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #9da19c;
  border-radius: 5px;
}
</style>
